'use client';

// ============================================================================
// LEAFLET MAP PICKER — SSR-safe dynamic wrapper
// react-leaflet requires window, so we load the inner component with ssr:false
// ============================================================================

import dynamic from 'next/dynamic';
import type { LeafletMapPickerProps } from './LeafletMapPickerInner';
import BrandedLoadingSpinner from '@/components/shared/BrandedLoadingSpinner';

const LoadingFallback = ({ className = '' }: { className?: string }) => (
  <div className={`bg-gray-50 border border-gray-200 rounded-md p-8 ${className}`}>
    <div className="flex flex-col items-center justify-center">
      <BrandedLoadingSpinner mode="compact" size="sm" showSurface={false} showProgressBar={false} />
      <p className="text-gray-600 text-sm">Loading map...</p>
    </div>
  </div>
);

const LeafletMapPickerInner = dynamic(
  () => import('./LeafletMapPickerInner'),
  { ssr: false, loading: () => <LoadingFallback /> }
);

export type { LeafletMapPickerProps };

const LeafletMapPicker: React.FC<LeafletMapPickerProps> = (props) => {
  return <LeafletMapPickerInner {...props} />;
};

export default LeafletMapPicker;
